import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor( private http: HttpClient ) { 
    // this.loadTheme();
  }

  // this.model.favicon,this.model.logo,this.model.siteTitle
    // this.model.favicon,this.model.logo,this.model.siteTitle
    setTheme(primary: string, btnPrimary: string, btnWarning: string, btnInfo: string,favicon:any,logo:any,siteTitle:string) {
      document.documentElement.style.setProperty('--primary', primary);
      document.documentElement.style.setProperty('--btn-primary', btnPrimary);
      document.documentElement.style.setProperty('--btn-warning', btnWarning);
      document.documentElement.style.setProperty('--btn-info', btnInfo);
      document.documentElement.style.setProperty('--favicon', favicon);
      document.documentElement.style.setProperty('--logo', logo);
      document.documentElement.style.setProperty('--siteTitle', siteTitle);
      
  
      localStorage.setItem('theme', JSON.stringify({ primary, btnPrimary, btnWarning, btnInfo,favicon,logo,siteTitle}));
    }
  
    loadTheme() {
      const theme = JSON.parse(localStorage.getItem('theme') || '{}');
      if (theme.primary) {
        this.setTheme(theme.primary, theme.btnPrimary, theme.btnWarning, theme.btnInfo, theme.favicon,theme.logo,theme.siteTitle);
      }
    }
  
    getAllTotalCount() {
      return this.http.get<any>(CONFIG.getAllDashboardTotalCountURL)
      .pipe(map(data => {        
          return data;
        }));
    }
  
    getPharmaciesDashboard(pharmData:any) {
      return this.http.post<any>(CONFIG.getPharmaciesList,pharmData)
        .pipe(map(data => {
          const pharArray = data.data.original.data || []
          return pharArray;
        }));
    }
  
    getHospitalDashboard(hospidata:any) {
      return this.http.post<any>(CONFIG.getHospitalsList,hospidata)
        .pipe(map(data => {
          const pharArray = data.data.data.original.data || []
          return pharArray;
        }));
    }
  
    getDoctorsDashboard(doctorData:any) {
      return this.http.post<any>(CONFIG.getDoctorsList,doctorData)
        .pipe(map(data => {
          const pharArray = data.data.data.original.data || []
          return pharArray;
        }));
    }
  
    getInventoryAnalyticsStats(data:any){
      let params = new HttpParams();
      //payload data as parameters
      params = params.set('pharmacy_id', data.pharmacy_id);
      params = params.set('filter', data.filter);
      params = params.set('type', data.type);
      params = params.set('limit',data.length || 10);
      params = params.set('start',data.start || 0);
      params = params.set('isExtended',data.isExtended || false);
      params = params.set('exportTable',data.exportTable || 0);
      params = params.set('exporttype',data.exporttype || '');
      return this.http.get<any>(CONFIG.getInventoryStatsData, { params: params })
      .pipe(map(data => {        
          return data;
        }));
    }
  
    getOrderAnalyticsStats(data:any){
      let params = new HttpParams();
      //payload data as parameters
      params = params.set('uuid', data.uuid);
      params = params.set('filter', data.filter);
      params = params.set('type', data.type);
      params = params.set('limit',data.length || 10);
      params = params.set('start',data.start || 0);
      params = params.set('isExtended',data.isExtended || false);
      params = params.set('exportTable',data.exportTable || 0);
      params = params.set('exporttype',data.exporttype || '');
      return this.http.get<any>(CONFIG.getOrderStatsData, { params: params })
      .pipe(map(data => {        
          return data;
        }));
    }
  
  
    getconsultation(data: any): Observable<any> {
      let params = new HttpParams()
          .set('uuid', data.uuid)
          .set('filter', data.filter)
          .set('type', data.type);
  
      return this.http.post<any>(CONFIG.getconsultationData, {}, { params })
          .pipe(map(response => {
              return response;
          }));
  }
  // lab 
  getlab(data: any): Observable<any> {
    let params = new HttpParams()
        .set('hospital_uuid', data.uuid)
        .set('filter', data.filter)
        .set('type', data.type);
  
    return this.http.post<any>(CONFIG.getlabData, {}, { params })
        .pipe(map(response => {
            return response;
        }));
  }
  
  // IPd
  
  getIPD(data: any): Observable<any> {
    let params = new HttpParams()
        .set('hospital_uuid', data.uuid)
        .set('filter', data.filter)
        .set('type', data.type);
  
    return this.http.post<any>(CONFIG.getIPDData,{},{ params })
        .pipe(map(response => {
            return response;
        }));
  }
  
  
  // Billing
  getbilling(data: any): Observable<any> {
    let params = new HttpParams()
        .set('hospital_uuid', data.uuid)
        .set('filter', data.filter)
        .set('type', data.type);
  
    return this.http.post<any>(CONFIG.getbillingData, {}, { params })
        .pipe(map(response => {
            return response;
        }));
  }
  
    getPurchaseAnalyticsStats(data:any){
      return this.http.post<any>(CONFIG.getPurchaseStatsData,data)
      .pipe(map(data => {   
        return data;
      }));
    }
  
    getItemWiseMargin(data:any){
      return this.http.post<any>(CONFIG.getItemWiseMarginData,data)
      .pipe(map(data => {        
          return data;
      }));
    }
  
    getPatientAnalyticsStats(data:any){
      let params = new HttpParams();
      //payload data as parameters
      params = params.set('pharmacy_uuid', data.uuid);
      params = params.set('filter', data.filter);
      params = params.set('type', data.type);
      params = params.set('limit',data.length || 10);
      params = params.set('start',data.start || 0);
      params = params.set('isExtended',data.isExtended || false);
      params = params.set('exportTable',data.exportTable || 0);
      params = params.set('exporttype',data.exporttype || '');
      return this.http.get<any>(CONFIG.getPatientStatsData, { params: params })
      .pipe(map(data => {        
          return data;
        }));
    }


    exportpatient(data: any) {
      return this.http.post<any>(CONFIG.exportpatient, data)
        .pipe(map(response => {
          return response;
        }));
    }
  
  
    
  
    // ot
    getOTAnalytics(data: any) {
      const payload = {
        hospital_uuid: data.uuid,
        filter: data.filter,
        type: data.type,
        date:data.date,
        procedure_id:data.procedure_id,
        ot_id:data.ot_id,
      };
    
      return this.http.post<any>(CONFIG.getOTData, payload)
        .pipe(map(response => {
          return response;
        }));
    }
  
  
    getSinglePharmacyId() {
      return this.http.post<any>(CONFIG.getSinglePharmacyID,{})
      .pipe(map(data => {        
          return data;
      }));
    }
  
  // patient-hospital start
    getSingleHospitalId() {
      return this.http.post<any>(CONFIG.getSingleHospitalID,{})
      .pipe(map(data => {        
          return data;
      }));
    }
  
    getPatientAnalyticsStatsHospital(data:any){
      let payload ={
        hospital_uuid: (data.uuid)?data.uuid:((data.hospital_uuid)?data.hospital_uuid:""),
        // hospitalid: (data.hospital_uuid)?data.hospital_uuid:"",
        filter: (data.filter)?data.filter:"",
        type: (data.type)?data.type:"",
        limit: data.length || 10,
        start: data.start || 0,
        isExtended:(data.isExtended)?data.isExtended:false, 
        isExport: data.isExport || 0,
        exporttype: data.exporttype || '',   
         
        
      }

      return this.http.post<any>(CONFIG.getPatientStatsDataHospital,payload)
      .pipe(map(data => {        
          return data;
        }));
    }

    // patient-hospital end
    getSingleDoctorId() {
      return this.http.post<any>(CONFIG.getSingleDoctorID,{})
      .pipe(map(data => {        
          return data;
      }));
    }
  }
  
  

